import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { OnboardingContext } from '../models';

export interface OnboardingSessionEvent {
  action: 'created' | 'closed' | 'switchTo';
  context?: OnboardingContext;
  entityType?: string;
  entityId?: string;
}

/**
 * Service to coordinate navigation between portfolio components and the onboarding session tab.
 * This avoids having to pass events through multiple layers of components.
 */
@Injectable({
  providedIn: 'root'
})
export class OnboardingNavigationService {
  /**
   * Emits when an onboarding session is created or should be switched to.
   * Parent components (customer-details, len-details, etc.) subscribe to this
   * to know when to show/switch to the Onboarding Session tab.
   */
  readonly sessionEvent$ = new Subject<OnboardingSessionEvent>();

  /**
   * Notifies that an onboarding session was created and the UI should switch to the onboarding tab
   */
  notifySessionCreated(context: OnboardingContext, entityType: string, entityId?: string): void {
    this.sessionEvent$.next({
      action: 'created',
      context,
      entityType,
      entityId
    });
  }

  /**
   * Notifies that the UI should switch to the onboarding tab for an existing session
   */
  notifySwitchToSession(context: OnboardingContext): void {
    this.sessionEvent$.next({
      action: 'switchTo',
      context
    });
  }

  /**
   * Notifies that an onboarding session was closed
   */
  notifySessionClosed(context: OnboardingContext): void {
    this.sessionEvent$.next({
      action: 'closed',
      context
    });
  }
}
